import React from "react";
import {
  faExclamationTriangle,
  faTimesCircle,
  faTimes,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";

const DraftWarningModal = ({ show, onHide, children }) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Body
        style={{
          borderTop: "5px solid #FFAE42",
        }}
      >
        <div className="close-buttonWarningModal text-right">
          <FontAwesomeIcon
            icon={faTimes}
            color="#000"
            onClick={onHide}
            size="1x"
          />
        </div>
        <div className="d-flex">
          <div className="pd-15">
            <FontAwesomeIcon
              icon={faExclamationTriangle}
              color="#FFAE42"
              size="3x"
            />
          </div>
          {children}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DraftWarningModal;
